import React, { Component, Suspense } from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
import Loadable from 'react-loadable';

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Router } from "react-router";
import Loader from './layout/Loader'
import Aux from "../hoc/_Aux";
import {loginRoute, panelRoutes} from "../Routes/routes";
import { history } from "../config/History";
import { ToastProvider } from "react-toast-notifications";

const AdminLayout = Loadable({
  loader: () => import('./layout/AdminLayout'),
  loading: Loader
});

class App extends Component {
  render() {
    const { isAuthenticated } = this.props;
    const menu = loginRoute.map((route, index) => {
      return (route.component) ? (
          <Route
          key={index}
          path={route.path}
          exact={route.exact}
          name={route.name}
          render={props =>
            isAuthenticated ? (      
              <Redirect to={panelRoutes.DASHBOARD.path} />
            ) : (
              <route.component {...props} />
            )
          } />
        
        ) : (null);
    });

    return (
      <Aux>
        <ToastProvider placement="bottom-right">
          <Suspense fallback={<Loader />}>
          <Router history={history}>
            <Switch>
              {menu}
              <Route path="/" component={AdminLayout} />
            </Switch>
            </Router>
          </Suspense>
        </ToastProvider>
      </Aux>
    );
  }
}


App.propTypes = {
  isAuthenticated: PropTypes.bool,
};

const mapStateToProps = state => ({
isAuthenticated: state.authentication.loggedIn,
});

export default connect(mapStateToProps)(App);
